var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/app/error-display/error-display.pug");
module.exports = (req['default'] || req).apply(req, [])